import { cn } from 'lib/utils'

/**
 * What a block shows when its asset simply has no data for it yet (no photos,
 * no income statement). Common, not an error, so it is quiet and says so in
 * plain words. Never an empty chart or a zero, which would read as a figure.
 */
export function EmptyBlock({ children, fill = false }: { children: React.ReactNode; fill?: boolean }) {
	return (
		<div className={cn('flex items-center justify-center rounded-xl bg-gray-50 px-6 py-8 text-center text-[18px] text-gray-500', fill && 'h-full')}>
			{children}
		</div>
	)
}
